/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_LessonsInputs */

const en_student_lessons = /** @type {(inputs: Student_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lessons`)
};

const he_student_lessons = /** @type {(inputs: Student_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעורים`)
};

/**
* | output |
* | --- |
* | "Lessons" |
*
* @param {Student_LessonsInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_lessons = /** @type {((inputs?: Student_LessonsInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_LessonsInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_lessons(inputs)
	return he_student_lessons(inputs)
});